import React, { useState, useEffect } from "react";
import {
  List,
  Input,
  Button,
  message,
  Modal,
  Form,
  // Spin,
} from "antd";
import baseRequest from "../../utils/baseRequest";
const { confirm } = Modal;
export default function PagesManage() {
  const [pages, setPages] = useState([]);
  const [formData, setFormData] = useState({
    app_route_path: "",
    h5_route_path: "",
    desc: "",
  });
  const [form] = Form.useForm();
  useEffect(() => {
    getPages();
  }, []);
  //创建页面路由
  const getPages = async () => {
    try {
      const base = baseRequest();
      const response = await fetch("/op/frontend_route/list", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          offset: 0,
          limit: 10,
          ...base,
        }),
      });
      const _data = await response.json();
      if (_data.ret === -1) {
        alert(_data.msg);
        return;
      }
      setPages(_data.data.list);
    } catch (error) {
      console.error(error);
    }
  };
  const handleCreate = async ({ id, app_route_path, h5_route_path, desc }) => {
    try {
      const base = baseRequest();
      const response = await fetch("/op/frontend_route/create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id,
          app_route_path,
          h5_route_path,
          desc,
          ...base,
        }),
      });
      const _data = await response.json();
      if (_data.ret === -1) {
        alert(_data.msg);
        return;
      }
      message.success("创建成功");
      setFormData({ app_route_path: "", h5_route_path: "", desc: "" });
      getPages();
    } catch (error) {
      console.error(error);
    }
  };
  const handleShowDialog = async (data) => {
    console.log("handle", data);
    let newData = { ...data };
    form.setFieldsValue(data);
    confirm({
      title: "编辑页面",
      content: (
        <Form
          preserve={false}
          form={form}
          // initialValues={{ ...newData }}
          onFinish={async (values) => {
            const { desc, app_route_path, h5_route_path } = values;
            try {
              const base = baseRequest();
              const response = await fetch("/op/frontend_route/update", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  id: newData.id,
                  app_route_path,
                  h5_route_path,
                  desc,
                  ...base,
                }),
              });
              const _data = await response.json();
              if (_data.ret === -1) {
                alert(_data.msg);
                return;
              }
              message.success("更新成功");
              setFormData({
                app_route_path: "",
                h5_route_path: "",
                desc: "",
              });
              getPages();
            } catch (error) {
              console.error(error);
            }
          }}
          onFinishFailed={() => console.log("Failed:")}
          autoComplete="off"
          layout="vertical"
          className="flex-1 grid grid-cols-[auto,35%,35%] gap-2"
        >
          <Form.Item
            label="页面名称"
            name="desc"
            rules={[{ required: true, message: "请输入页面名称" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="APP页面值"
            name="app_route_path"
            rules={[{ required: true, message: "请输入APP页面值" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="H5页面值"
            name="h5_route_path"
            rules={[{ required: true, message: "请输入H5页面值" }]}
          >
            <Input />
          </Form.Item>
        </Form>
      ),
      width: 800,
      height: 300,
      maskClosable: false,
      centered: true,
      destroyOnClose: true,
      icon: null,
      onOk: async () => {
        console.log("OK");
        form.submit();
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };
  return (
    <div className="my-4 min-h-[30vh]">
      <List split={false}>
        <div className="my-6 flex items-center justify-between">
          <div className="flex-1 grid grid-cols-[auto,35%,35%] gap-2">
            <Input
              disabled
              value={formData.desc}
              placeholder="页面名称"
              onChange={(e) => {
                setFormData((old) => ({
                  ...old,
                  desc: e.target.value,
                }));
              }}
            />
            <Input
              disabled
              value={formData.app_route_path}
              onChange={(e) => {
                setFormData((old) => ({
                  ...old,
                  app_route_path: e.target.value,
                }));
              }}
              placeholder="APP页面值"
            />
            <Input
              disabled
              value={formData.h5_route_path}
              onChange={(e) => {
                setFormData((old) => ({
                  ...old,
                  h5_route_path: e.target.value,
                }));
              }}
              placeholder="H5页面值"
            />
          </div>
          <Button
            disabled
            type="primary"
            className="ml-2"
            onClick={() => handleCreate({ id: pages.length + 1, ...formData })}
          >
            新增+
          </Button>
        </div>
        <div className="overflow-scroll" style={{ maxHeight: "60vh" }}>
          {pages.map((it) => (
            <div className="mt-2" key={it.id}>
              <List.Item style={{ padding: 0 }}>
                <div className="w-full">
                  <div className="flex items-center justify-between rounded-lg px-4 py-2  bg-[#dcdcdc80]">
                    <div className="flex items-start">
                      <div className="flex flex-nowrap">
                        <span className="text-base w-[64px] inline-block">
                          {it.desc}
                        </span>
                        <span className="mx-1 mr-3">|</span>
                      </div>
                      <p className="flex flex-wrap gap-2">
                        <span className="text-gray-500 whitespace-nowrap">
                          <span className="text-xs text-gray-400">APP：</span>
                          {it.app_route_path}
                        </span>
                        <span className="text-gray-500 whitespace-nowrap">
                          <span className="text-xs text-gray-400">H5：</span>
                          {it.h5_route_path}
                        </span>
                      </p>
                    </div>
                    <div className="flex-row hidden">
                      <span
                        className="px-2 py-1 rounded-lg cursor-pointer whitespace-nowrap"
                        onClick={() => handleShowDialog(it)}
                      >
                        编辑
                      </span>
                      <span
                        className="px-2 py-1 rounded-lg text-[#ff000064] cursor-pointer whitespace-nowrap"
                        onClick={() => {
                          confirm({
                            title: "警告",
                            content: "确定要删除此页面吗？",
                            maskClosable: false,
                            centered: true,
                            destroyOnClose: true,
                            onOk: async () => {
                              try {
                                const base = baseRequest();
                                const response = await fetch(
                                  "/op/frontend_route/delete",
                                  {
                                    method: "POST",
                                    headers: {
                                      "Content-Type": "application/json",
                                    },
                                    body: JSON.stringify({
                                      id: it.id,
                                      ...base,
                                    }),
                                  }
                                );
                                const _data = await response.json();
                                if (_data.ret === -1) {
                                  alert(_data.msg);
                                  return;
                                }
                                message.success("删除成功");
                                getPages();
                              } catch (error) {
                                console.error(error);
                              }
                            },
                            onCancel() {},
                          });
                        }}
                      >
                        删除
                      </span>
                    </div>
                  </div>
                </div>
              </List.Item>
            </div>
          ))}
        </div>
      </List>
    </div>
  );
}
